import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ApiService } from '../../core/api.service';
import { ServiceService } from '../../service.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';



@Component({
  selector: 'app-employee-attendance-beta-details',
  templateUrl: './employee-attendance-beta-details.component.html',
  styleUrls: ['./employee-attendance-beta-details.component.css']
})
export class EmployeeAttendanceBetaDetailsComponent implements OnInit, AfterViewInit {

  attendanceList: any[] = [];
  filteredAttendanceList: any[] = []; // New property for filtered data
  employeeDropdown: any[] = [];
  departmentDropdown: any[] = [];
  isLoading: boolean = true;
  selectedMonthLabel: string = '';
  maxDate: Date = new Date();

  // Stats
  attendancePercentage: number = 0;
  absentPercentage: number = 0;
  fullDayCount: number = 0;
  absentCount: number = 0;
  sickLeaveCount: number = 0;
  localLeaveCount: number = 0;
  vacationCount: number = 0;

  // Filters
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  currentFilter: string = 'all'; // Track current filter

  isFactoryManager: boolean = false;
  filterForm: FormGroup

  constructor(

    private apiService: ServiceService,
    private methodService: ApiService,
    private fb: FormBuilder,
    private router: ActivatedRoute,
    private datePipe: DatePipe

  ) {
    this.filterForm = this.fb.group({
      selectedEmployee: [""],
      selectedDepartment: [""],
    });
  }


  ngOnInit(): void {
    console.log('🔍 Details Component - ngOnInit called');

    // Set default date range to current month
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    this.range.setValue({
      start: firstDayOfMonth,
      end: today
    });

    this.router.queryParams.subscribe({
      next: (params) => {
        console.log('📋 Query Params received:', params);
        if (params['id']) {
          const employeeId = params['id'];
          console.log('👤 Employee ID:', employeeId);
          console.log('📅 Month from URL:', params['month']);

          this.filterForm.controls['selectedEmployee'].setValue(employeeId);

          // NEW LOGIC: Handle month parameter
          if (params['month']) {
            // Parse the month parameter (format: YYYY-MM)
            const [year, month] = params['month'].split('-');
            const selectedYear = parseInt(year);
            const selectedMonth = parseInt(month) - 1; // JavaScript months are 0-indexed

            // Set date range to the entire selected month
            const today = new Date();
const startDate = new Date(selectedYear, selectedMonth, 1);
const lastDayOfMonth = new Date(selectedYear, selectedMonth + 1, 0);

const isCurrentMonth = selectedYear === today.getFullYear() && selectedMonth === today.getMonth();
const endDate = isCurrentMonth ? today : lastDayOfMonth;

this.range.setValue({
  start: startDate,
  end: endDate
});

            console.log(`📅 Set date range to: ${startDate.toDateString()} - ${endDate.toDateString()}`);
          } else if (params['from_date'] && params['to_date']) {
            // Fallback for old links that use date range
            this.range.setValue({
              start: new Date(params['from_date'] + 'T00:00:00'),
              end: new Date(params['to_date'] + 'T00:00:00')
            });
          } else if (params['date']) {
            // Fallback for old links that use single date
            const selectedDate = new Date(params['date'] + 'T00:00:00');
            this.range.setValue({
              start: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1),
              end: new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0)
            });
          }
          // else: keeps the default current month set at the top of ngOnInit

          this.isFactoryManager =
            localStorage.getItem('userTypecon')?.toUpperCase() === 'FACTORY_MANAGER';
          console.log('🏭 Is Factory Manager:', this.isFactoryManager);

          this.fetchReportData();
        } else {
          console.log('❌ No ID parameter found');
          this.isLoading = false;
        }
      },
      error: (err) => {
        console.error('Error fetching query params:', err);
        this.isLoading = false;
      }
    })
  }

  /**
 * Set default date range (current month or saved dates)
 */
  private setDefaultDateRange(employeeId: string): void {
    const savedFromDate = localStorage.getItem(`attendance_from_${employeeId}`);
    const savedToDate = localStorage.getItem(`attendance_to_${employeeId}`);

    if (savedFromDate && savedToDate) {
      const fromDate = new Date(savedFromDate + 'T00:00:00');
      const toDate = new Date(savedToDate + 'T00:00:00');
      this.range.setValue({ start: fromDate, end: toDate });
    } else {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.range.setValue({ start: firstDay, end: today });
    }
  }

  /**
   * Format date for API (YYYY-MM-DD)
   */
  private formatDateForAPI(date: Date | null): string {
    if (!date) return '';
    return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }

  /**
   * Clear date range and reset to current month
   */
  clearDateRange(): void {
    const employeeId = this.filterForm.controls['selectedEmployee'].value;
    this.setDefaultDateRange(employeeId);
    this.fetchReportData();
  }



  ngAfterViewInit(): void {
    this.addScrollShadow();
  }

  // ==================== STATUS DISPLAY LOGIC ====================

  /**
   * Get display status based on employee_status and attendance_status
   * 1. If employee_status is not null, show employee_status (working or break)
   * 2. If employee_status is null, show attendance_status
   */
  getDisplayStatus(item: any): string {
    if (!item) return '-';

    // Check if employee_status exists and is not null/undefined
    if (item.employee_status !== null && item.employee_status !== undefined) {
      return item.employee_status; // Show working or break
    }

    // Fallback to attendance_status if employee_status is null
    return item.attendance_status || '-';
  }

  /**
   * Get badge class based on status (working or break)
   */
  getStatusBadgeClass(item: any): string {
    const status = this.getDisplayStatus(item) || '';
    const statusLower = status.trim().toLowerCase();

    if (statusLower === 'working') {
      return 'bg-success';
    } else if (statusLower === 'in break') {
      return 'bg-warning text-dark';
    } else {
      // For attendance_status fallback values
      switch (statusLower) {
        case 'present':
          return 'bg-success';
        case 'half day':
        case 'half day - late in':
        case 'half day - early out':
          return 'bg-warning';
        case 'holiday':
          return 'bg-warning text-dark';
        case 'absent':
          return 'bg-danger';
        default:
          return 'bg-secondary';
      }
    }
  }

  // ==================== SCROLL SHADOW EFFECT ====================

  addScrollShadow(): void {
    const tableResponsive = document.querySelector('.table-responsive');
    if (tableResponsive) {
      tableResponsive.addEventListener('scroll', () => {
        if (tableResponsive.scrollTop > 0) {
          tableResponsive.classList.add('scrolled');
        } else {
          tableResponsive.classList.remove('scrolled');
        }
      });
    }
  }

  // ==================== BREAK TIME METHODS ====================

  /**
   * Extract all break times from break_in or break_out array
   */
  getBreakTimes(breakArray: any[]): string[] {
    if (!breakArray || !Array.isArray(breakArray) || breakArray.length === 0) {
      return [];
    }

    const times: string[] = [];

    breakArray.forEach(breakItem => {
      if (typeof breakItem === 'object' && breakItem !== null) {
        // Handle object format: [{ "1": "13:01" }, { "2": "15:30" }]
        Object.values(breakItem).forEach(value => {
          if (typeof value === 'string' && this.isValidTime(value)) {
            times.push(value);
          }
        });
      } else if (typeof breakItem === 'string' && this.isValidTime(breakItem)) {
        // Handle string format: ["13:01", "15:30"]
        times.push(breakItem);
      }
    });

    return times;
  }

  /**
   * Check if break data exists and has valid times
   */
  hasBreakData(breakArray: any[]): boolean {
    return this.getBreakTimes(breakArray).length > 0;
  }

  /**
   * Validate if string is a valid time format (HH:MM)
   */
  isValidTime(timeString: string): boolean {
    if (!timeString || timeString === '00:00' || timeString === '-' || timeString === 'null') {
      return false;
    }

    // Basic time format validation (HH:MM)
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return timeRegex.test(timeString);
  }

  // ==================== FILTER METHODS ====================

  /**
   * Filter attendance list by status or leave type
   */
  filterRecords(filterType: string): void {
    console.log(`🔍 Filtering by: ${filterType}`);

    this.currentFilter = filterType;

    if (filterType === 'all') {
      this.filteredAttendanceList = [...this.attendanceList];
      console.log('📋 Showing all records:', this.filteredAttendanceList.length);
    } else {
      this.filteredAttendanceList = this.attendanceList.filter(item => {
        const itemStatus = (item.attendance_status || item.status || item.work_status || '').toLowerCase().trim();
        const itemLeaveType = (item.leave_type || item.leave || '').toLowerCase().trim();

        switch (filterType) {
          case 'absent':
            return itemStatus.includes('absent') || itemStatus === 'a';
          case 'present':
            // Check if record looks present
            const looksPresent = itemStatus.includes('present') ||
              itemStatus === 'p' ||
              itemStatus.includes('full day') ||
              itemStatus.includes('full') ||
              (item.work_in && item.work_in !== '00:00' && item.work_in !== '-' && item.work_in !== 'null');

            // Check if record is explicitly absent
            const isExplicitlyAbsent = itemStatus.includes('absent') || itemStatus === 'a';

            // Return true if it looks present AND is not explicitly absent
            return looksPresent && !isExplicitlyAbsent;
          case 'sick':
            return itemLeaveType.includes('sick');
          case 'local':
            return itemLeaveType.includes('local');
          case 'vacation':
            return itemLeaveType.includes('vacation');
          default:
            return true;
        }
      });
      console.log(`📋 Filtered ${filterType} records:`, this.filteredAttendanceList.length);
    }
  }

  /**
   * Check if current filter is active
   */
  isFilterActive(filterType: string): boolean {
    return this.currentFilter === filterType;
  }

  /**
   * Get active filter badge text
   */
  getActiveFilterText(): string {
    switch (this.currentFilter) {
      case 'sick':
        return 'Showing: Sick Leave Records';
      case 'local':
        return 'Showing: Local Leave Records';
      case 'vacation':
        return 'Showing: Vacation Leave Records';
      case 'absent':
        return 'Showing: Absent Records';
      case 'present':
        return 'Showing: Present Records';
      default:
        return 'Showing: All Records';
    }
  }

  // ==================== TIME FORMATTING METHODS ====================

  /**
   * Format overtime hours from "HH:mm" format to a readable string
   */
  formatOvertimeHours(timeString: string): string {
    if (!timeString || timeString === '00:00') return '-';

    const [hours, minutes] = timeString.split(':').map(Number);
    if (hours === 0 && minutes === 0) return '-';

    if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}m`;
    }
  }

  /**
   * Safely extract time value from object, array, or string
   */
  extractTimeValue(timeValue: any): string {
    if (!timeValue) return '-';

    // If it's an array (for break times, but handle if work_in/work_out ever become arrays)
    if (Array.isArray(timeValue)) {
      const times = this.getBreakTimes(timeValue);
      return times.length > 0 ? times[0] : '-'; // Return first time if array
    }

    // If it's already a string, return it
    if (typeof timeValue === 'string') {
      return this.isValidTime(timeValue) ? timeValue : '-';
    }

    // If it's an object, try to extract time value (keep your existing logic)
    if (typeof timeValue === 'object') {
      const timeProperties = ['time', 'value', 'break_time', 'timestamp', 'time_value', 'hour'];

      for (const prop of timeProperties) {
        if (timeValue[prop] && typeof timeValue[prop] === 'string' && this.isValidTime(timeValue[prop])) {
          return timeValue[prop];
        }
      }

      // If no common property found, try to get first property
      const keys = Object.keys(timeValue);
      if (keys.length > 0) {
        const firstValue = timeValue[keys[0]];
        if (typeof firstValue === 'string' && this.isValidTime(firstValue)) {
          return firstValue;
        }
      }

      return '-';
    }

    return '-';
  }

  /**
   * Get CSS class for leave type badges
   */
  getLeaveTypeClass(leaveType: string): string {
    if (!leaveType) return 'bg-light text-dark';

    const type = leaveType.trim().toLowerCase();
    switch (type) {
      case 'sick leave':
        return 'bg-danger';
      case 'local leave':
        return 'bg-warning text-dark';
      case 'vacation':
        return 'bg-info text-dark';
      default:
        return 'bg-light text-dark';
    }
  }

  // ==================== DATE FORMATTING METHODS ====================

  /**
   * Format month for API (YYYY-MM format)
   */


  /**
   * Get current month in YYYY-MM format
   */


  private getAdminId(): string {
    return localStorage.getItem('admin_id') ||
      localStorage.getItem('userId') ||
      localStorage.getItem('user_id') ||
      localStorage.getItem('employee_id') ||
      localStorage.getItem('id') ||
      'unknown-admin';
  }


  // ==================== DATA FETCHING METHODS ====================

  fetchReportData(): void {
    console.log('📊 fetchReportData called');

    const employeeId = this.filterForm.controls['selectedEmployee'].value;

    if (!employeeId) {
      console.error('❌ No employee ID found');
      this.isLoading = false;
      return;
    }

    const adminId = this.getAdminId();

    // NEW DATE LOGIC
    const fromDate = this.formatDateForAPI(this.range.value.start ?? null);
    const toDate = this.formatDateForAPI(this.range.value.end ?? null);
    if (!fromDate || !toDate) {
      console.error('❌ Invalid date range');
      this.isLoading = false;
      return;
    }

    const apiUrl = `attendance-view/employee?admin_id=${adminId}&from_date=${fromDate}&to_date=${toDate}&employee_id=${employeeId}`;

    console.log('🔗 API Endpoint:', apiUrl);
    console.log('📅 Date Range:', `${fromDate} to ${toDate}`);

    this.methodService.get(apiUrl).subscribe({
      next: (response) => {
        console.log('✅ RAW API RESPONSE:', response);
        this.attendanceList = response.data || [];
        this.filteredAttendanceList = [...this.attendanceList];
        this.currentFilter = 'all';

        if (this.attendanceList.length) {
          this.debugTimeData();
        }

        this.calculateAttendanceStats();
        this.isLoading = false;
        setTimeout(() => this.addScrollShadow(), 100);
      },
      error: (err) => {
        console.error('❌ Error fetching attendance:', err);
        this.isLoading = false;
      }
    });
  }


  // ==================== MONTH FILTER HANDLER ====================

  /**
   * Handle month filter change
   */






  // ==================== STATS CALCULATION ====================

  calculateAttendanceStats(): void {
    console.log('📊 calculateAttendanceStats called, records:', this.attendanceList.length);

    if (!this.attendanceList.length) {
      console.log('📭 No attendance data found');
      this.resetStats();
      return;
    }

    // ENHANCED DEBUGGING - Check the actual data structure
    console.log('🔍 FULL DATA STRUCTURE DEBUG:');
    console.log('📋 First record full structure:', JSON.stringify(this.attendanceList[0], null, 2));

    // Check all available fields in the first record
    const firstRecord = this.attendanceList[0];
    console.log('🔑 All available fields in first record:', Object.keys(firstRecord));

    // Check what values actually exist for attendance_status and leave_type
    const allStatuses = [...new Set(this.attendanceList.map(item => item.attendance_status))];
    const allLeaveTypes = [...new Set(this.attendanceList.map(item => item.leave_type))];

    console.log('🎯 All unique attendance_status values:', allStatuses);
    console.log('🎯 All unique leave_type values:', allLeaveTypes);

    // Reset all counters
    this.resetStats();

    // Check each record and count based on actual data
    this.attendanceList.forEach((item, index) => {
      // Try multiple possible field names for status
      const status = item.attendance_status || item.status || item.work_status || item.attendance || '';
      const leaveType = item.leave_type || item.leave || '';

      const statusLower = String(status).toLowerCase().trim();
      const leaveTypeLower = String(leaveType).toLowerCase().trim();

      // DEBUG: Log each record for analysis
      if (index < 3) { // Only log first 3 to avoid console spam
        console.log(`📅 Record ${index + 1} analysis:`, {
          status: statusLower,
          leaveType: leaveTypeLower,
          rawStatus: status,
          rawLeaveType: leaveType,
          work_in: item.work_in,
          work_out: item.work_out
        });
      }

      // Count leave types with flexible matching
      if (leaveTypeLower.includes('sick')) {
        this.sickLeaveCount++;
      } else if (leaveTypeLower.includes('local')) {
        this.localLeaveCount++;
      } else if (leaveTypeLower.includes('vacation')) {
        this.vacationCount++;
      }

      // Count attendance status with flexible matching
      if (statusLower.includes('present') || statusLower === 'p' || statusLower === 'full day' || statusLower === 'full') {
        this.fullDayCount++;
      } else if (statusLower.includes('absent') || statusLower === 'a') {
        this.absentCount++;
      } else if (item.work_in && item.work_in !== '00:00' && item.work_in !== '-' && item.work_in !== 'null') {
        // If there's work_in time, count as present (fallback logic)
        this.fullDayCount++;
        console.log(`✅ Record ${index + 1} counted as PRESENT (has work_in time):`, item.work_in);
      } else if (item.work_out && item.work_out !== '00:00' && item.work_out !== '-' && item.work_out !== 'null') {
        // If there's work_out time, count as present (fallback logic)
        this.fullDayCount++;
        console.log(`✅ Record ${index + 1} counted as PRESENT (has work_out time):`, item.work_out);
      }
    });

    const totalDays = this.attendanceList.length;

    // Try different calculation methods
    this.attendancePercentage = totalDays > 0
      ? Math.round((this.fullDayCount / totalDays) * 100)
      : 0;

    this.absentPercentage = totalDays > 0
      ? Math.round((this.absentCount / totalDays) * 100)
      : 0;

    console.log('🎯 FINAL CALCULATION RESULTS:', {
      totalDays,
      presentCount: this.fullDayCount,
      absentCount: this.absentCount,
      sickLeaveCount: this.sickLeaveCount,
      localLeaveCount: this.localLeaveCount,
      vacationCount: this.vacationCount,
      calculatedAttendancePercentage: this.attendancePercentage,
      calculatedAbsentPercentage: this.absentPercentage
    });

    // If still 0%, let's check what's actually in the data
    if (this.attendancePercentage === 0) {
      console.warn('⚠️ ATTENDANCE PERCENTAGE IS 0% - INVESTIGATING...');
      this.investigateZeroPercentage();
    }
  }

  /**
   * Debug time data structure
   */
  private debugTimeData(): void {
    if (this.attendanceList.length > 0) {
      console.log('🕒 DEBUG: Time data structure in first record:');
      const firstRecord = this.attendanceList[0];

      console.log('work_in:', {
        value: firstRecord.work_in,
        type: typeof firstRecord.work_in,
        extracted: this.extractTimeValue(firstRecord.work_in)
      });

      console.log('break_out:', {
        value: firstRecord.break_out,
        type: typeof firstRecord.break_out,
        isArray: Array.isArray(firstRecord.break_out),
        arrayLength: Array.isArray(firstRecord.break_out) ? firstRecord.break_out.length : 'N/A',
        extractedTimes: this.getBreakTimes(firstRecord.break_out)
      });

      console.log('break_in:', {
        value: firstRecord.break_in,
        type: typeof firstRecord.break_in,
        isArray: Array.isArray(firstRecord.break_in),
        arrayLength: Array.isArray(firstRecord.break_in) ? firstRecord.break_in.length : 'N/A',
        extractedTimes: this.getBreakTimes(firstRecord.break_in)
      });

      console.log('work_out:', {
        value: firstRecord.work_out,
        type: typeof firstRecord.work_out,
        extracted: this.extractTimeValue(firstRecord.work_out)
      });
    }
  }

  /**
   * Investigate why percentage is 0%
   */
  private investigateZeroPercentage(): void {
    console.log('🔍 INVESTIGATING ZERO PERCENTAGE ISSUE:');

    // Check what's actually in each record
    this.attendanceList.slice(0, 5).forEach((item, index) => { // Check first 5 only
      console.log(`🔍 Record ${index + 1} detailed analysis:`, {
        date: item.date,
        // Check all possible status fields
        attendance_status: item.attendance_status,
        status: item.status,
        attendance: item.attendance,
        work_status: item.work_status,
        // Check all possible leave fields
        leave_type: item.leave_type,
        leave: item.leave,
        leave_status: item.leave_status,
        // Check work times
        work_in: item.work_in,
        work_out: item.work_out,
        break_in: item.break_in,
        break_out: item.break_out,
        // Check other potential indicators
        has_adjustment: item.has_adjustment,
        total_overtime_hours: item.total_overtime_hours
      });
    });

    // Count records with work_in time (might indicate presence)
    const recordsWithWorkIn = this.attendanceList.filter(item =>
      item.work_in && item.work_in !== '00:00' && item.work_in !== '-' && item.work_in !== 'null'
    ).length;

    // Count records with work_out time
    const recordsWithWorkOut = this.attendanceList.filter(item =>
      item.work_out && item.work_out !== '00:00' && item.work_out !== '-' && item.work_out !== 'null'
    ).length;

    console.log(`📊 Records analysis:`);
    console.log(`   - With work_in time: ${recordsWithWorkIn}/${this.attendanceList.length}`);
    console.log(`   - With work_out time: ${recordsWithWorkOut}/${this.attendanceList.length}`);
    console.log(`   - Total records: ${this.attendanceList.length}`);
  }

  private resetStats(): void {
    this.attendancePercentage = 0;
    this.absentPercentage = 0;
    this.fullDayCount = 0;
    this.absentCount = 0;
    this.sickLeaveCount = 0;
    this.localLeaveCount = 0;
    this.vacationCount = 0;
  }

  /**
   * Calculate percentage for progress bars
   */
  getProgressPercentage(count: number): number {
    if (!this.attendanceList.length) return 0;
    return (count / this.attendanceList.length) * 100;
  }






}